interface Props {
  active: "16x9" | "9x16";
  onChange: (format: "16x9" | "9x16") => void;
}

export default function FormatTabs({ active, onChange }: Props) {
  return (
    <div className="flex gap-2 justify-center mb-6">
      <button
        onClick={() => onChange("16x9")}
        className={`px-4 py-2 rounded-lg font-medium transition-colors ${
          active === "16x9"
            ? "bg-primary-600 text-white"
            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
        }`}
      >
        16:9 Master
      </button>
      <button
        onClick={() => onChange("9x16")}
        className={`px-4 py-2 rounded-lg font-medium transition-colors ${
          active === "9x16"
            ? "bg-primary-600 text-white"
            : "bg-gray-700 text-gray-300 hover:bg-gray-600"
        }`}
      >
        9:16 Social
      </button>
    </div>
  );
}
